module.exports = __webpack_public_path__ + "fonts/Firasansbookitalic.woff2";